import { useQuery } from "react-query";
import { getTerms } from "services/terms.service";

export default function useTerms(id) {
  return useQuery(["terms"], async () => await getTerms());
}
